import { Shape } from "three";
import { memo, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
const Extrude = memo(function ShapeMesh({ points, extrude, ...props }) {
	const shape = useMemo(() => {
		const shape$1 = new Shape();
		for (let i = 0; i < points.length; i++) {
			let p = points[i];
			if ("isVector2" in p) p = [p.x, p.y];
			if (i === 0) shape$1.moveTo(p[0], p[1]);
			else shape$1.lineTo(p[0], p[1]);
		}
		shape$1.closePath();
		return shape$1;
	}, [points]);
	return /* @__PURE__ */ jsx("mesh", {
		...props,
		children: /* @__PURE__ */ jsx("extrudeGeometry", { args: [shape, extrude] })
	});
});
Extrude.displayName = "Shape";
export { Extrude };

//# sourceMappingURL=index209.js.map